import {
  object, string, date, bool, number, boolean,
} from 'yup';

import { TASK_STATUSES, TASK_ASSIGNEE_TYPES, TASK_TYPES } from 'resources/task/task.constants';

const taskSchema = object({
  id: string(),
  created_on: date().required(),
  updated_on: date().required(),

  company_id: string().required(),
  deal_id: string().optional(),
  template_id: string().optional(),
  document_id: string().optional(),

  milestone_id: string().required(),
  milestone_order: number().required(),

  assignee_id: string().nullable(),
  assignee_type: string().oneOf(Object.values(TASK_ASSIGNEE_TYPES)).nullable(),

  status: string().oneOf(Object.values(TASK_STATUSES)).default(TASK_STATUSES.OPEN),
  content: string().required(),
  description: string().default(''),
  predefined: bool().default(false), // for tasks with predefined content
  is_hidden_from_client: bool().default(false),
  type: string().oneOf(Object.values(TASK_TYPES)).default(TASK_TYPES.TASK),
  is_optional: bool().default(false),
  is_skipped: bool().default(false),
  email_from: string().nullable(), // only for task type email

  completed_on: date().nullable(),
  completed_by: string().nullable(),
  viewed_by_realtor_on: date().nullable(), // only for completed tasks
  viewed_by_client_on: date().nullable(), // only for completed tasks

  due_in_days: number().integer().nullable(),
  is_after_action: boolean().default(true),
  due_relative_date: string().nullable(),

  send_time: string().nullable(),
  time_zone: string().nullable(),

  is_auto: bool().default(false),
});

export default taskSchema;
